import type { PageAdType } from '@/modules/adv/types'

const BELONGS_TO_FULLSCREEN: Partial<Record<PageAdType, boolean>> = {
    sidebar: false,
    sidebar_bottom: false,
    leaderboard: false,
    leaderboard_rest: false,
    sidebar_fullscreen: true,
    sidebar_bottom_fullscreen: true,
}

type FallbackRule = {
    noFill?: boolean
    noRoom?: boolean
}

const FALLBACK_RULES: Partial<Record<PageAdType, FallbackRule>> = {
    sticky_mobile: { noFill: true },
    sticky_mobile_non_game_page: { noFill: true },
    leaderboard: { noRoom: true },
}

export function matchesFullscreenMode(placement: PageAdType, isFullscreen: boolean): boolean {
    const belongsToFullscreen = BELONGS_TO_FULLSCREEN[placement]
    return belongsToFullscreen === undefined || belongsToFullscreen === isFullscreen
}

export function getFallbackRule(placement: PageAdType): FallbackRule | undefined {
    return FALLBACK_RULES[placement]
}

export function hasRenderedBox(el: HTMLElement): boolean {
    const rect = el.getBoundingClientRect()
    return rect.width > 0 && rect.height > 0
}

export function fitsRenderedBox(el: HTMLElement, boxWidth: number): boolean {
    return el.getBoundingClientRect().width >= boxWidth
}

export function isElementCovered(el: HTMLElement): boolean {
    if (typeof document.elementFromPoint !== 'function') {
        return false
    }

    const rect = el.getBoundingClientRect()
    const left = Math.max(rect.left, 0)
    const top = Math.max(rect.top, 0)
    const right = Math.min(rect.right, window.innerWidth)
    const bottom = Math.min(rect.bottom, window.innerHeight)

    if (right <= left || bottom <= top) {
        return false
    }

    const points: [number, number][] = [
        [(left + right) / 2, (top + bottom) / 2],
        [left + 1, top + 1],
        [right - 1, bottom - 1],
    ]

    return points.some(([x, y]) => {
        const hit = document.elementFromPoint(x, y)
        return !hit || !el.contains(hit)
    })
}
